module.exports = __webpack_public_path__ + "img/clearable.2d4feee3.svg";